import React, { useEffect } from 'react';
import TermsDoc from '../components/Terms/TermsDoc';
import TermsNav from '../components/Terms/TermsNav';

const TermsAndConditions = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className='bg-gray-200'>
            <div className='container max-auto'>
                <div className="grid grid-cols-7">
                    <div className="md:col-span-2 col-span-7">
                        <TermsNav />
                    </div>
                    <div className="md:col-span-5 col-span-7">
                        <TermsDoc />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;